/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TableCurrentVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * @class TableCurrentVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.TableCurrentVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.TableCurrentVMBehavior.prototype */ {
      __name: "TableCurrentVMBehavior",

      watchedAttributes: {
        anchor: ["currentRow", "currentColumn", "offset"]
      },

      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        if (!widget?.setCurrentRow) {
          return;
        }

        const tableNode = controller.getAnchorNode();
        const app = tableNode.getApplication();
        const uiNode = app.uiNode();
        const currentRow = tableNode.attribute("currentRow");

        if (!app.scheduler.hasPendingNavigationCommands()) {
          if (!app.scheduler.hasPendingScrollCommands()) {
            this._handleCurrentRow(data, tableNode, widget);
          }
          this._handleCurrentColumn(tableNode, widget);

          if (widget.updateCurrentItem) {
            widget.updateCurrentItem();
          }
        }

        const hasFocus = tableNode.getId() === uiNode.attribute("focus");
        const parentForm = tableNode.getAncestor("Form");
        let visibleId = null;
        if (parentForm) {
          visibleId = parentForm.attribute("visibleId");
        }
        // if table has vm focus and no visibleId is set on its parent form, then we display it
        if (hasFocus && (!visibleId || visibleId === -1)) {
          controller.ensureVisible();
        }

        // =====================================
        if (controller.updateMultiRowSelectionRoot && data.oldCurrentRow !== currentRow) {
          controller.multiRowSelectionRoot = currentRow;
        }

        controller.updateMultiRowSelectionRoot = true;
        // =====================================

        data.oldCurrentRow = currentRow;
      },

      /**
       * Set the current row on the table widget
       * @param {any} data The behavior data
       * @param {cls.TableNode} tableNode
       * @param {cls.TableWidgetBase} tableWidget
       */
      _handleCurrentRow: function (data, tableNode, tableWidget) {
        if (!tableWidget.setCurrentRow) {
          return;
        }
        const currentRow = tableNode.attribute("currentRow");
        const offset = tableNode.attribute("offset");
        const size = tableNode.attribute("size");
        const localCurrentRow = currentRow - offset;

        const ensureRowVisible = currentRow !== data.oldCurrentRow && localCurrentRow === 0 && size > 0;
        tableWidget.setCurrentRow(localCurrentRow, ensureRowVisible, currentRow);
      },

      /**
       * Set the current column on the table widget
       * @param {cls.TableNode} tableNode
       * @param {cls.TableWidgetBase} tableWidget
       */
      _handleCurrentColumn: function (tableNode, tableWidget) {
        if (!tableWidget.setCurrentColumn) {
          return;
        }
        let hasChanged = false;
        const currentColumn = tableNode.attribute("currentColumn");
        if (tableWidget.getCurrentColumn) {
          hasChanged = currentColumn !== tableWidget.getCurrentColumn();
        }
        // look to manually scroll to the new column if not currenty visible
        if (!hasChanged) {
          return;
        }

        tableWidget.setCurrentColumn(currentColumn);

        if (tableWidget.scrollToCurrentColumn) {
          tableWidget.scrollToCurrentColumn();
        }
      }
    };
  });
});
